<template>
    <div :class="['list-row', layout]">
        <i :class="[icon, 'icon', fontSize]"></i>
        <paragraph :type="'p'" :variation="fontSize">
            {{ text }}
        </paragraph>
    </div>
</template>

<script>
import Paragraph from './paragraph.vue';

export default {
    name: 'list-row',
    components: { Paragraph },
    props: {
        layout: String,
        icon: String,
        text: String,
        fontSize: {
            type: String,
            default: 'medium',
        },
    },
};
</script>

<style lang="scss">
@import 'global/default';

.list-row {
    display: flex;
    justify-content: flex-start;

    i {
        margin-right: 0.5em;
    }

    p {
        margin: 0;
    }

    .icon {
        &.large {
            font-size: $font-size-body-lg;
            line-height: $line-height-body-lg;
        }
        &.medium {
            font-size: $font-size-body-default;
            line-height: $line-height-body-default;
        }
        &.small {
            font-size: $font-size-body-xs;
            line-height: $line-height-body-xs;
        }
        &.label {
            font-size: $font-size-label;
            line-height: $line-height-label;
        }
        &.button-medium {
            font-size: $font-size-button-default;
            line-height: $line-height-button-default;
        }
        &.button-large {
            font-size: $font-size-button-lg;
            line-height: $line-height-button-lg;
        }
    }

    &.vertical-middle {
        align-items: center;
    }
    &.vertical-top {
        align-items: flex-start;
    }
}

</style>
